import { Component, Input, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { FormArray } from '@angular/forms';

import { BreakpointObserver } from '@angular/cdk/layout';

import { calcGroup } from '@library/common/models';

@Component({
   selector: 'calculator-items',
   templateUrl: './calculator-items.component.html',
   styleUrls: ['./calculator-items.component.scss']
})
export class CalculatorItemsComponent implements OnInit {

   @Input()
   set items( items: FormArray ) {
      if ( items == null ) {
         this._items = new FormArray([ calcGroup() ]);
      } else {
         this._items = items;
      }

      if ( this._items.length === 0 ) {
         this._items.push( calcGroup() );
      }
   }

   get items() { return this._items; }

   private _items: FormArray;

   carouselIndex = 0;

   @ViewChild('calcitems') calcitems: ElementRef;

   // carousel breakpoint
   get isMobileView(): boolean {
      return this.breakpoint$.isMatched( '(max-width: 400px)' );
   }

   constructor(
      private breakpoint$: BreakpointObserver,
      private changes: ChangeDetectorRef,
   ) { }

   ngOnInit() {
   }

   addCalcItem(): void {
      if ( this.items.length >= 100 ) { return; }

      this.items.push( calcGroup() );
      this.changes.detectChanges();

      this.carouselIndex = this.items.length - 1;

      if ( !this.isMobileView ) {
         this.scrollToEnd();
      }
   }

   removeCalcItem( index: number ): void {
      if ( this.items.length === 1 ) { return; }

      this.items.removeAt( index );

      if ( this.carouselIndex && this.carouselIndex >= this.items.length ) {
         this.moveCalc( -1 );
      }
   }

   moveCalc( n: number ): void {
      this.carouselIndex += n;

      const calclen = this.items.length;
      if ( this.carouselIndex < 0 ) { this.carouselIndex = calclen - 1; }
      if ( this.carouselIndex >= calclen ) { this.carouselIndex = 0; }
   }

   scrollToEnd(): void {
      if ( !this.calcitems ) { return; }
      const calc = this.calcitems.nativeElement as HTMLElement;
      if ( calc ) {
         setTimeout( _ =>
            calc.scroll({
               left: calc.scrollWidth,
               behavior: 'smooth'
            }), 1);
      }
   }
}
